// builders/dummyDucts.js
import { getDuctAsync } from "../api/apiFunctionWrappers";

export const EMPTY_GUID = "00000000-0000-0000-0000-000000000000";

// Placeholder ducts, used when a scenario has no duct selected (e.g. freshly
// seeded default scenarios) or when the selected duct was deleted from the
// library. width = duct width, depth = duct height above the mounting plate
// (same fields the builders read from a real duct article).
export const DUMMY_DUCTS = {
  enclosure: { width: 60, depth: 80 }, // left / right / top duct of the enclosure
  sections: { width: 40, depth: 60 },  // duct above every section
};

export const isEmptyId = (id) =>
  !id || String(id).toLowerCase() === EMPTY_GUID;

// A duct placement is a placeholder when it references no article.
// referenceId is persisted by the backend, so this also works after reload
// without any extra field in the placement model.
export const isDummyDuct = (ductPlacement) =>
  !!ductPlacement && isEmptyId(ductPlacement.referenceId);

/**
 * Returns the duct article for refId, or a placeholder article when no duct
 * is selected / the duct no longer exists.
 * Network or server errors are NOT swallowed - the layout should fail visibly
 * instead of silently using placeholders.
 *
 * @param {string} refId  settings.ductsEnclosureId / settings.ductsSectionsId
 * @param {"enclosure"|"sections"} kind
 */
export async function resolveDuctArticle(refId, kind) {
  if (!isEmptyId(refId)) {
    try {
      const article = await getDuctAsync(refId);
      if (article) return article;
    } catch (err) {
      if (err?.response?.status !== 404) throw err;
    }
    console.warn(`Duct ${refId} not found – using placeholder duct`);
  }

  const dims = DUMMY_DUCTS[kind] ?? DUMMY_DUCTS.enclosure;
  return {
    id: EMPTY_GUID,
    name: "Placeholder duct",
    size: { width: dims.width, height: dims.depth, depth: dims.depth },
    isDummy: true,
  };
}
